import * as _4 from 'lodash4';
import { GetCrossCourseLinkedSectionsCommand } from '../../../components/section_corequisite/commands/get_cross_course_linked_sections_command';
import { LinkedSectionModelEntry } from '../models/linked_sections_model';
export class LoadCrossCourseLinkedSectionsFacade {
  constructor(private getCrossCourseLinkedSectionsCommand: GetCrossCourseLinkedSectionsCommand) {}

  loadCrossCourseLinkedSections(sectionLinkResponse: LinkedSectionModelEntry) {
    const linkedSectionIds = Object.keys(sectionLinkResponse).filter(
      (sectionId) => !_4.isEmpty(sectionLinkResponse[sectionId])
    );

    const includeStatus = true;
    return linkedSectionIds.map((id) =>
      this.getCrossCourseLinkedSectionsCommand(id as unknown as number, includeStatus)
    );
  }
}

angular
  .module('capability-ng-scheduler')
  .service('ngLoadCrossCourseLinkedSectionsFacade', LoadCrossCourseLinkedSectionsFacade);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/sections/facades/load_cross_course_linked_sections_facade.ts